const REDIRECT_URI = `${window.location.origin}/login/callback`;
const OKTA_TESTING_DISABLEHTTPSCHECK = false;

// Environment variables with fallback values for development
const REACT_APP_OKTA_ISSUER_ID_DEV = process.env.REACT_APP_OKTA_ISSUER_ID_DEV || 'https://id-qa.eaton.com/oauth2/aus18kyuno5D6fqcG0h8';
const REACT_APP_OKTA_CLIENT_ID_DEV = process.env.REACT_APP_OKTA_CLIENT_ID_DEV || '0oa27fdtm7yGzkCwW0h8';

const REACT_APP_OKTA_CLIENT_ID_PROD = process.env.REACT_APP_OKTA_CLIENT_ID_PROD;
const REACT_APP_OKTA_ISSUER_ID_PROD = process.env.REACT_APP_OKTA_ISSUER_ID_PROD;

const PROD_HOSTNAMES = [
  'gridsolutions.eaton.com',
  'smpservices-prod2.eastus.cloudapp.azure.com',
  'smpservices-prod3.eastus.cloudapp.azure.com'
];

const isProd = PROD_HOSTNAMES.includes(window.location.hostname);

const oktaConfig = {
    redirectUri: REDIRECT_URI,
    clientId: isProd ? REACT_APP_OKTA_CLIENT_ID_PROD :  REACT_APP_OKTA_CLIENT_ID_DEV,
    issuer: isProd ? REACT_APP_OKTA_ISSUER_ID_PROD : REACT_APP_OKTA_ISSUER_ID_DEV,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
};

export default oktaConfig;
